import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { LayoutService } from '../../../../RefModules/_metronic/core';
import { SubheaderService } from '../../../../RefModules/_metronic/partials/layout';
import { BreadcrumbItemModel } from '../../../../RefModules/_metronic/partials/layout/subheader/_models/breadcrumb-item.model';
import { CalculationResult } from '../../models/calculationModels';
import { SubHeaderData } from '../../models/sub-header-data';
import { UserMatrixModel } from '../../models/user-matrix-model';
import { CreateDataSheetReportComponent } from '../create-data-sheet-report/create-data-sheet-report.component';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';

@Component({
    selector: 'app-informate-sub-header',
    templateUrl: './informate-sub-header.component.html',
    styleUrls: ['./informate-sub-header.component.scss'],
})
export class InformateSubHeaderComponent implements OnInit, OnChanges {
    @Input() headerData: SubHeaderData;
    @Input() calcOutput: CalculationResult;
    @Output() newMatrix = new EventEmitter<UserMatrixModel>();

    imgSrc: string;

    subheaderCSSClasses = '';
    subheaderContainerCSSClasses = '';
    subheaderMobileToggle = false;
    subheaderDisplayDesc = false;
    subheaderDisplayDaterangepicker = false;
    title$: Observable<string>;
    breadcrumbs$: Observable<BreadcrumbItemModel[]>;
    description$: Observable<string>;
    temp = false;
    hideButtons: boolean = false;
    currentOrganizationName: string;
    currentInstanceName: string;
    currentAssetType: string;
    constructor(
        private layout: LayoutService,
        private subheader: SubheaderService,
        private modalService: NgbModal
    ) {
        this.title$ = this.subheader.titleSubject.asObservable();
        this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
        this.description$ = this.subheader.descriptionSubject.asObservable();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.imgSrc = this.headerData.defaultImageSrc;
        if (this.calcOutput) {
            this.hideButtons = true;
            if (this.calcOutput?.output?.general?.warnings) {
                let res = this.calcOutput.output.general.warnings.some((w) => w.severity <= 1);
                if (res === true) {
                    this.hideButtons = false;
                }
            }
        }
    }

    ngOnInit() {
        this.subheaderCSSClasses = this.layout.getStringCSSClasses('subheader');
        this.subheaderContainerCSSClasses = this.layout.getStringCSSClasses('subheader_container');
        this.subheaderMobileToggle = this.layout.getProp('subheader.mobileToggle');
        this.subheaderDisplayDesc = this.layout.getProp('subheader.displayDesc');
        this.subheaderDisplayDaterangepicker = this.layout.getProp('subheader.displayDaterangepicker');

        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstanceName = localStorage.getItem('currentInstanceName');
        }
        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrganizationName = localStorage.getItem('selectedOrganizationName');
        }
        if (localStorage.getItem('currentAssetType')) {

            this.currentAssetType = localStorage.getItem('currentAssetType');
        }
    }

    onMouseOver(): void {
        this.imgSrc = this.headerData.mouseOverImageSrc;
    }

    onMouseOut(): void {
        this.imgSrc = this.headerData.defaultImageSrc;
    }

    open() {
        this.modalService
            .open(ReportViewerComponent, {
                ariaLabelledBy: 'modal-basic-title',
                // backdrop: 'static',
                size: 'xl',
                // keyboard: false
            })
            .result.then(
                (result) => {
                    // this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }
    open1() {
        // this.modalService.open(content, {
        //   ariaLabelledBy: 'modal-basic-title',
        //   backdrop: 'static',
        //   size: 'lg',
        //   keyboard: false
        // }).result.then((result) => {
        //   // this.closeResult = `Closed with: ${result}`;
        // }, (reason) => {
        //   // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        // });
        // window.open('/report-viewer','_blank');
        // this.popoutService.openPopoutModal("");
    }

    submitForm(e) {
        if (this.standardForm.valid) {
            //Submit form logic here!
        } else {
        }
    }

    @Output() standardconfirm = new EventEmitter();
    @ViewChild('standardForm', { static: false }) public standardForm: NgForm;
    formData = {
        matrix_add: 'matrix_add 1',
        quantity: '',
        joint_optional: '',
        comments_value: '',
        data_sheet_ref: '',
        prepared: '',
        customer: '',
        project_number: '',
        joint_id: '',
        vessel_ref: '',
        permanent_tag: '',
        pid_number: '',
        bolt_coating: '',
        site: '',
        project_name: '',
        joint_location: '',
        work_pack: '',
        line_number: '',
        iso_number: '',
        gasket_filter: '',
        reference_document: '',
        instructed_by: '',
        company: '',
        position: '',
        date: '',
        assembled_by: '',
        tightened_by_one: '',
        tightened_by_two: '',
        report_completed: '',
        customer_acceptance: '',
        comments: '',
        unit_lubricant_new: '',
        unit_value_new: '',
    };

    changeUnit(event) {
        this.formData.unit_lubricant_new = event.value;
    }

    confirmnow() {
        let standardFormData = this.standardForm.value;
        this.standardconfirm.emit(standardFormData);
    }

    // new matrix created
    newMatrixCreated(eventData) {
        this.newMatrix.emit(eventData);
    }
}
